var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCitizenIdCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1377",
    d: "M0-682.665H14v14H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43190",
    "data-name": "Group 43190",
    transform: "translate(4121 -18112)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16047",
    "data-name": "Rectangle 16047",
    width: 16,
    height: 16,
    transform: "translate(-4121 18112)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1371",
    transform: "translate(-4120 18795.664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1373",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1375",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1381",
    transform: "translate(0.41 2.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1383",
    d: "M-581.49-393.428h-11.17a1,1,0,0,1-1-1v-6.228a1,1,0,0,1,1-1h11.17a1,1,0,0,1,1,1v6.228A1,1,0,0,1-581.49-393.428Z",
    transform: "translate(593.665 401.666)",
    fill: "none",
    stroke: "#b2b9c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1385",
    transform: "translate(3.087 4.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1387",
    d: "M-98.358-49.178a1.03,1.03,0,0,1-1.03,1.03,1.03,1.03,0,0,1-1.03-1.03,1.03,1.03,0,0,1,1.03-1.03A1.03,1.03,0,0,1-98.358-49.178Z",
    transform: "translate(100.417 50.208)",
    fill: "none",
    stroke: "#b2b9c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1389",
    transform: "translate(2.058 7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1391",
    d: "M-98.356,0c-1.137,0-2.059.461-2.059,1.03v1.03H-96.3V1.03C-96.3.461-97.219,0-98.356,0Z",
    transform: "translate(100.416)",
    fill: "none",
    stroke: "#b2b9c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1393",
    transform: "translate(8.647 5.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1395",
    d: "M-157.371,0h-3.295",
    transform: "translate(160.666 0)",
    fill: "none",
    stroke: "#b2b9c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1397",
    transform: "translate(8.647 7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1399",
    d: "M-157.371,0h-3.295",
    transform: "translate(160.666)",
    fill: "none",
    stroke: "#b2b9c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1401",
    transform: "translate(8.647 8.647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1403",
    d: "M-101.167,0h-2.118",
    transform: "translate(103.285 0)",
    fill: "none",
    stroke: "#b2b9c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitizenIdCard);
export default __webpack_public_path__ + "static/media/citizenID-card.edddad2a3edf94735f689a08ea58be2f.svg";
export { ForwardRef as ReactComponent };